import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { logSecurityEvent, anonymizeData } from "@/utils/security";

export function useDataProcessingTracking() {
  const logDataProcessing = async (
    requestType: string,
    purpose: string,
    metadata?: Record<string, any>
  ) => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      
      if (!user) {
        throw new Error('No authenticated user found');
      }

      // Anonymize any sensitive data in metadata
      const safeMetadata = metadata ? JSON.parse(
        anonymizeData(JSON.stringify(metadata))
      ) : {};

      const { error } = await supabase
        .from('ai_data_processing')
        .insert({
          user_id: user.id,
          request_type: requestType,
          processing_purpose: purpose,
          metadata: safeMetadata,
          anonymized: true,
          encryption_status: 'encrypted'
        });

      if (error) {
        throw error;
      }

      // Log the data processing event
      await logSecurityEvent({
        eventType: 'data_processing',
        resourceType: 'ai_processing',
        actionType: requestType,
        metadata: {
          purpose,
          anonymized: true
        }
      });

    } catch (error) {
      console.error('Error logging data processing:', error);
      toast.error('Kunne ikke logge databehandling');
    }
  };

  return { logDataProcessing };
}